export default function decodeProtocolBuffer({ typePath, buffer, root }) {
  const Type = root.lookupType(typePath);

  const decoded = Type.decode(buffer);

  return Type.toObject(decoded, {
    enums: String,
    longs: Number,
    defaults: true
  });
}
